// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2y3Fr","list":"PatternAutocomplete_list__1rg9e"};